import { initialState } from "@/store/modules/permissions/state";

export default {
  RESET_STORE: state => {
    Object.assign(state, {
      ...initialState(),
      company: state.company
    });
  },

  SET_EMAIL: (state, payload) => {
    state.member.email = payload;
  },

  SET_ACCOUNT_TYPE: (state, payload) => {
    state.member.type = payload;
  },

  SET_ALL_FACILITIES_ACCESS: (state, payload) => {
    state.member.allFacilitiesAccess = payload;
  },

  SET_FACILITIES_IDS: (state, payload) => {
    state.member.facilitiesIds = [...payload];
  },

  SET_FACILITIES_GROUPS_IDS: (state, payload) => {
    state.member.facilitiesGroupsIds = [...payload];
  },

  SET_ACTIVE_DIALOG: (state, payload) => {
    state.activeDialog = payload;
  },

  SET_COMPANY: (state, payload) => {
    state.company = payload;
  },

  SET_PERMISSIONS: (state, payload) => {
    state.member.permissions = payload;
  },

  SET_PERMISSION_TYPE: (state, payload) => {
    state.member.permissionType = payload;
  },

  SET_MEMBER: (state, payload) => {
    state.member = {
      ...payload
    };
  },

  SET_MODE: (state, payload) => {
    state.mode = payload;
  }
};
